"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaCrimeResponse$ = exports.AreaCrimeResponse$outboundSchema = exports.AreaCrimeResponse$inboundSchema = void 0;
exports.areaCrimeResponseToJSON = areaCrimeResponseToJSON;
exports.areaCrimeResponseFromJSON = areaCrimeResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areacrimewrapper_js_1 = require("./areacrimewrapper.js");
const datameta_js_1 = require("./datameta.js");
/** @internal */
exports.AreaCrimeResponse$inboundSchema = z.object({
    data: z.array(areacrimewrapper_js_1.AreaCrimeWrapper$inboundSchema),
    meta: datameta_js_1.DataMeta$inboundSchema,
});
/** @internal */
exports.AreaCrimeResponse$outboundSchema = z.object({
    data: z.array(areacrimewrapper_js_1.AreaCrimeWrapper$outboundSchema),
    meta: datameta_js_1.DataMeta$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaCrimeResponse$;
(function (AreaCrimeResponse$) {
    /** @deprecated use `AreaCrimeResponse$inboundSchema` instead. */
    AreaCrimeResponse$.inboundSchema = exports.AreaCrimeResponse$inboundSchema;
    /** @deprecated use `AreaCrimeResponse$outboundSchema` instead. */
    AreaCrimeResponse$.outboundSchema = exports.AreaCrimeResponse$outboundSchema;
})(AreaCrimeResponse$ || (exports.AreaCrimeResponse$ = AreaCrimeResponse$ = {}));
function areaCrimeResponseToJSON(areaCrimeResponse) {
    return JSON.stringify(exports.AreaCrimeResponse$outboundSchema.parse(areaCrimeResponse));
}
function areaCrimeResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaCrimeResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaCrimeResponse' from JSON`);
}
//# sourceMappingURL=areacrimeresponse.js.map